import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  en: { code: 'en', name: 'EN', fullName: 'English' },
  es: { code: 'es', name: 'ES', fullName: 'Español' },
  ru: { code: 'ru', name: 'RU', fullName: 'Русский' }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('nimny-language');
    if (saved && LANGUAGES[saved]) {
      return saved;
    }
    // Check browser language
    const browserLang = navigator.language?.slice(0, 2);
    if (LANGUAGES[browserLang]) {
      return browserLang;
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('nimny-language', language);
    // Update html lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const t = (translationObj) => {
    if (!translationObj) return '';
    return translationObj[language] || translationObj['en'] || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
